import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CommsLpStatusModelSchema = z
  .object({
    id: z.string(),
    label: z.string(),
    precedence: z.number()
  })
  .strict()

const CommsLpStatusModelFields = makeFieldKeys(CommsLpStatusModelSchema)

export type CommsLpStatusModel = z.infer<typeof CommsLpStatusModelSchema>

function validateCommsLpStatusModel(data: unknown): CommsLpStatusModel {
  try {
    return validateWithZodSchema(CommsLpStatusModelSchema, data, 'comms lp status model')
  } catch (error) {
    throw new Error(`Comms lp status model validation failed: ${error}`)
  }
}
